module.exports = __webpack_public_path__ + "img/SVK.0b4bd9a6.svg";